<template>
    <div class="wrapper">
        <div class="header">
            <van-nav-bar title="业务员信息" />
        </div>
        <div class="content">
            <div class="user-info">
                <div class="user-img">
                    <img :src="salesmanInfo.saleman_img" alt="">
                </div>
                <van-cell title="姓名" :value="salesmanInfo.name"/>
                <van-cell title="工号" :value="salesmanInfo.job_num"/>
                <van-cell title="职位" :value="salesmanInfo.duties" v-if="salesmanInfo.duties"/>
                <van-cell title="区域" :value="salesmanInfo.region" v-if="salesmanInfo.region"/>
                <van-cell title="视频介绍" v-if="salesmanInfo.video_file"/>
                <div class="video" v-if="salesmanInfo.video_file">
                    <video :src="salesmanInfo.video_file" controls="controls" style="width: 100%" id="myVideo">
                        您的浏览器不支持 video 标签。
                    </video>
                    <div class="bg-zzc" @click="handleShow" v-show="show">
                        <img src="https://www.shoudaole.cn/uploads/default/dovideo.jpg" alt="">
                    </div>
                </div>
                <van-cell title="描述" v-if="salesmanInfo.describe"/>
                <div class="ms" v-html="salesmanInfo.describe"></div>
                <van-cell title="详细信息" v-if="salesmanInfo.detailed" />
                <div class="detailed" v-html="salesmanInfo.detailed"></div>
            </div>
            <div class="company-info">
                <p>公司简介</p>
                <div v-html="companyInfo.content"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import {getUrlParamsTools} from "../util/tools";
    import {getSaleInfoByNumService} from '../service/salesmanService';
    import {getWxSharService} from '../service/weChatService'
    import {Toast} from 'vant';
    import wx from 'weixin-js-sdk'
    import {getCompanyProfileService} from "../service/untilService";

    export default {
        name: "SalesmanQuery",
        data(){
            return{
                saleId:null,
                salesmanInfo: {},//业务员信息
                companyInfo: {},
                imgUrl: '',
                lineLink: '',
                descContent: '',
                shareTitle: '',
                show: true,
            }
        },
        mounted() {
            this.saleId = getUrlParamsTools('sid');
            this.getSaleInfo();
            this.getCompanyProfile();
        },
        methods:{
            //获取业务员信息
            getSaleInfo(){
                if(!this.saleId){
                    Toast('业务员信息获取失败，请刷新');
                    return;
                }
                getSaleInfoByNumService(this.saleId).then(res => {
                    if(res.status === 1){
                        this.salesmanInfo = res.datas;
                        this.share();
                    }else{
                        Toast(res.msg);
                    }
                }).catch(err => {
                    console.log(err);
                })
            },

            //分享
            share(){
                const that = this;
                getWxSharService(encodeURIComponent(location.href.split('#')[0])).then(result => {
                    if (result.status === 1) {
                        wx.config({
                            // debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                            'appId': result.datas.appId, // 公众号名称，由商户传入
                            'timestamp': result.datas.timestamp, // 时间戳，自1970年以来的秒数
                            'nonceStr': result.datas.nonceStr, // 随机串
                            'signature': result.datas.signature,// 微信签名
                            'jsApiList': ['updateTimelineShareData', 'updateAppMessageShareData'] // 必填，需要使用的JS接口列表
                        });
                        wx.ready(function () {
                            //分享到朋友圈
                            wx.updateTimelineShareData({
                                title: that.salesmanInfo.describe, // 分享标题
                                link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                                imgUrl: that.salesmanInfo.share_file || that.salesmanInfo.saleman_img, // 分享图标
                                success: function () {
                                    // Toast('分享成功');
                                }
                            });
                            //分享给朋友
                            wx.updateAppMessageShareData({
                                title: that.salesmanInfo.name, // 分享标题
                                desc: that.salesmanInfo.describe || '',//分享描述
                                link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                                imgUrl: that.salesmanInfo.share_file || that.salesmanInfo.saleman_img, // 分享图标
                                success: function () {
                                    // Toast('分享成功');
                                }
                            });
                        });
                    } else {
                        Toast(result.msg);
                    }
                })
            },

            //获取公司简介
            getCompanyProfile(){
                getCompanyProfileService().then(res => {
                    if(res.status === 1){
                        this.companyInfo = res.datas;
                    }else{
                        // alert(1)
                    }
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    .wrapper{
        .header {
            position: fixed;
            width: 100%;
            top: 0;
            z-index: 999999;
            margin-bottom: 46px;
        }
        .content {
            margin-top: 50px;
            .user-info {
                .user-img {
                    padding: 0.3125rem 0.5rem;
                    box-sizing: border-box;
                }
                img {
                    width: 100%;
                    height: 100%;
                }
                .ms,
                .describe {
                    text-indent: 24px;
                    padding: 0.3125rem 0.5rem;
                    box-sizing: border-box;
                }
                .video {
                    position: relative;
                    .bg-zzc {
                        position: absolute;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100%;
                        img {
                            width: 100%;
                            height: 100%;
                        }
                    }
                }
            }
            .company-info {
                p{
                    text-align: center;
                    padding: 10px 0;
                }
                .company-box {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-direction: column;
                    .info-box {
                        .item {
                            margin-top: 10px;
                            .bg-img {
                                width: 100%;
                                height: 100%;
                            }
                        }
                    }
                    .company-introduce {
                        padding: 0.3125rem 0.5rem;
                        box-sizing: border-box;
                        text-indent: 24px;
                    }
                    .down-box {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        flex-direction: column;
                        padding-bottom: 100px;
                        img {
                            width: 60%;
                            height: 60%;
                        }
                    }
                }
            }
        }
    }
</style>
<style>
    .company-info img{
        width: 100%;
        height: 100%;
    }
    p {
        background: #ffffff;
        padding: 0.3125rem 0.5rem;
        box-sizing: border-box;
    }
    p > img {
        width: 100%;
        height: 100%;
        padding: 10px 0;
    }
    .van-cell {
        color: #59dfe2;
    }
    .van-cell__title {
        flex: 30%;
    }
    .van-cell__value {
        flex: 70%;
        text-align: left;
    }
    .van-cell:not(:last-child)::after{
        border: none!important;
    }
</style>